import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["element", "form", "input"]
  static values = { defaultText: String }

  connect() {
    if (this.elementTarget.innerText.trim() === "") {
      this.elementTarget.innerText = this.defaultTextValue
    }
  }

  save() {
    if (this.elementTarget.innerText.trim() === this.defaultTextValue) {
      return
    }
    const form = this.formTarget
    const input = this.inputTarget
    input.value = this.elementTarget.innerText.trim()
    form.requestSubmit()
    if (this.elementTarget.innerText.trim() === "") {
      this.elementTarget.innerText = this.defaultTextValue
    }
  }

  prepareEditing() {
    if (this.elementTarget.innerText.trim() === this.defaultTextValue) {
      this.elementTarget.innerText = ""
    }
  }
}